import { purify } from "../../../_src/components/purify";

export function getResults(url, resultId, filterId, url2 = '', loaderId) {
  function search() {
    var form = document.querySelector(`${filterId}`);
    var data = new FormData(form);

    document.querySelectorAll(`${filterId} fieldset`).forEach(function (el) {
      el.classList.add("disabled")
    })

    document.querySelector(`${resultId}`).innerHTML = '';

    if (loaderId) {
      document.querySelector(`.loader-${loaderId}`).classList.remove("hidden")
    }

    fetch(`${url}`, {
      method: "POST",
      body: data
    }).then((response) => {
      return response.text();
    }).then((response) => {
      document.querySelector(`${resultId}`).innerHTML += purify(response);
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      document.querySelectorAll(`${filterId} fieldset`).forEach(function (el) {
        el.classList.remove("disabled")
      })

      if (loaderId) {
        document.querySelector(`.loader-${loaderId}`).classList.add("hidden")
      }
    });

    if(url2 != "") {
      fetch(`${url2}`, {
        method: "POST",
        body: data
      }).then((response) => {
        return response.text();
      }).then((response) => {
        document.querySelector(`${resultId}`).innerHTML += purify(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        document.querySelectorAll(`${filterId} fieldset`).forEach(function (el) {
          el.classList.remove("disabled")
        })
      });
    }
  }

  document.querySelector(`${filterId}`).addEventListener("change", function () { setTimeout(() => { search() }, 100) });

  return search();
}

if (document.querySelector("#filter-budgetsExecution")) {
  getResults("/senar/transparencia-e-prestacao-de-contas/lei-de-diretrizes-orcamentarias/ajax/budgets.html", "#result-budgetsExecution", "#filter-budgetsExecution", "/senar/transparencia-e-prestacao-de-contas/lei-de-diretrizes-orcamentarias/ajax/budgets-previous.html", "budgets");
}

if (document.querySelector("#filter-accountingStatements")) {
  getResults("/senar/transparencia-e-prestacao-de-contas/lei-de-diretrizes-orcamentarias/ajax/demonstrations.html", "#result-accountingStatements", "#filter-accountingStatements", undefined, "demonstrations");
}

if (document.querySelector("#filter-peopleManagement")) {
  getResults("/senar/transparencia-e-prestacao-de-contas/lei-de-diretrizes-orcamentarias/ajax/management.html", "#result-peopleManagement", "#filter-peopleManagement", undefined, "management");
}
